type LoadingReducerState = object & {
  loading?: boolean;
  adding?: boolean;
  fetching?: boolean;
  saving?: boolean;
  calculating?: boolean;
  syncing?: boolean;
  replacing?: boolean;
  sending?: boolean;
  metaSaveAttempting?: boolean;
};

type LoadingSelectorState = {
  [reducer: string]: LoadingReducerState | undefined;
};

const isLoading = (reducer: LoadingReducerState): boolean =>
  Boolean(
    reducer.loading ||
      reducer.adding ||
      reducer.fetching ||
      reducer.saving ||
      reducer.calculating ||
      reducer.syncing ||
      reducer.replacing ||
      reducer.sending ||
      reducer.metaSaveAttempting,
  );

const getReducerState = (state: LoadingSelectorState, reducer: string): LoadingReducerState | null =>
  state[reducer] ?? null;

const isLoadingSelector = (state: LoadingSelectorState, reducers: string | readonly string[]): boolean => {
  const resolvedReducers =
    typeof reducers === 'string'
      ? [getReducerState(state, reducers)]
      : reducers.map((reducer) => getReducerState(state, reducer)).filter((reducer) => reducer);

  if (!resolvedReducers || resolvedReducers.length === 0) {
    return false;
  }
  return resolvedReducers.some((item) => item && !!isLoading(item));
};

export default isLoadingSelector;
